module.exports = __webpack_public_path__ + "static/img/card1_1.62db86d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/card1_1.png
// module id = 1r57
// module chunks = 1